export default __webpack_public_path__ + "static/media/myclassic1.32088b9b.png";